import * as runtime from '@/api/runtime'
import {
  BatchSchoolStatisticsPageLoadRequest,
  BatchSchoolStatisticsPageLoadRequestToJSON,
  BatchSchoolStatisticsPageLoadResult,
  BatchSchoolStatisticsPageLoadResultFromJSON
} from '@/api/models/batch'

import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemRequest'
import {
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemResult'

import {
  BatchSchoolStatisticsGetPredefinedSettingResult,
  BatchSchoolStatisticsGetPredefinedSettingResultFromJSON
} from '@/api/models/batch/BatchSchoolStatisticsGetPredefinedSettingResult'
import {
  BatchSchoolStatisticsGetPredefinedSettingRequest,
  BatchSchoolStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchSchoolStatisticsGetPredefinedSettingRequest'

/**
 * 学校統計(共通)
 */
export class BatchSchoolStatisticsApi extends runtime.BaseAPI {
  // 画面初期化時の前回入力内容復帰データ取得
  async readInitialPattern(
    request: BatchSchoolStatisticsPageLoadRequest
  ): Promise<BatchSchoolStatisticsPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchSchoolStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchSchoolStatisticsPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  // 定義取得
  async getPredefinedSetting(
    request: BatchSchoolStatisticsGetPredefinedSettingRequest
  ): Promise<BatchSchoolStatisticsGetPredefinedSettingResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchSchoolStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchSchoolStatisticsGetPredefinedSettingResultFromJSON(jsonValue)
    ).value()
  }

  // セレクト項目取得
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }
}
